import React,{useEffect,useState} from 'react';
import './App.css';
import Recipe from './Recipe';
import pic from './halo-halo.png';

function App() {

  const APP_ID='5580063e';
  const APP_KEY='6be7a9e1d36f076be896f63600df65f0';

  const[recipes,setRecipes]=useState([]);
  const[search,setSearch]=useState("");
  const[query,setQuery]=useState('chicken');


  useEffect(()=>{
    getRecipes();
  },[query]);

  async function getRecipes() {
    const response = await fetch(
      `https://api.edamam.com/search?q=${query}&app_id=${APP_ID}&app_key=${APP_KEY}&from=0&to=3&calories=591-722&health=alcohol-free`
    );
    const data = await response.json();
    setRecipes(data.hits);

  }

  const updateSearch=e=>{
    setSearch(e.target.value);
    console.log(search);
  };


  const getSearch=e=>{
    e.preventDefault();
    setQuery(search);
    setSearch('');
  };


  return (
    <div className="App">
      <div className='hh'>
      <h1 className='heading'>Recipe Finder</h1>
      <img className='img' src={pic} alt='Recipe'/>
      </div>
    <form onSubmit={getSearch} className='search-form'>
      <input className='search-bar' placeholder='Search any Recipe' type="text" value={search} onChange={updateSearch}  />
      <button className='search-button' type='submit'>Search</button>
    </form>
    <div className='recipes'>
    {recipes.map(recipe=>(
      <Recipe 
      id={recipe.recipe.label}
      key={recipe.recipe.label}
      title={recipe.recipe.label} 
      calories={recipe.recipe.calories} 
      image={recipe.recipe.image}
      ingredients={recipe.recipe.ingredients}/>
    ))}

</div>
    </div>

  );
}

export default App;
